import {Component, Input, OnInit} from '@angular/core';
import {BreadcrumbService} from 'xng-breadcrumb';
import {TokenStorageService} from '../_services/token-storage.service';
import {OrderService, OrderView} from '../shared/order.service';
import {BrandThemeService} from '../shared/brand-theme.service';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {
  /** When true, hide page chrome (used inside Profile tabs). */
  @Input() embedded = false;

  role: 'buyer' | 'seller' = 'buyer';
  orders: OrderView[] = [];
  loading = true;
  error = '';
  imagesBaseUrl = '';

  constructor(
    private tokenStorage: TokenStorageService,
    private breadcrumbService: BreadcrumbService,
    private orderService: OrderService,
    private brandThemeService: BrandThemeService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (!this.embedded) {
      this.breadcrumbService.set('@Orders', 'Orders');
    }
    if (!this.tokenStorage.getToken()) {
      this.router.navigate(['/login']);
      return;
    }
    environment.then((env) => {
      this.imagesBaseUrl = env['images'] || '';
    });
    this.load();
  }

  setRole(role: 'buyer' | 'seller'): void {
    this.role = role;
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    this.orderService.listMine(this.role).subscribe({
      next: rows => {
        this.orders = rows || [];
        this.loading = false;
      },
      error: err => {
        this.error = err?.error?.error || 'Could not load orders.';
        this.loading = false;
      }
    });
  }

  amount(order: OrderView): string {
    return `${(order.amountCents / 100).toFixed(2)} ${(order.currency || '').toUpperCase()}`;
  }

  partyName(order: OrderView): string {
    return this.role === 'buyer'
      ? (order.sellerName || 'Seller')
      : (order.buyerName || 'Buyer');
  }

  partyUrl(order: OrderView): string | null {
    const url = this.role === 'buyer' ? order.sellerUrl : order.buyerUrl;
    return (url || '').trim() || null;
  }

  partyAvatar(order: OrderView): string {
    const raw = this.role === 'buyer' ? order.sellerAvatarUrl : order.buyerAvatarUrl;
    return this.brandThemeService.resolveMediaUrl(raw, this.imagesBaseUrl);
  }

  payoutLabel(order: OrderView): string {
    switch ((order.payoutStatus || '').toLowerCase()) {
      case 'transferred':
        return 'Transferred';
      case 'pending_connect':
        return 'Pending Connect';
      case 'platform_held':
        return 'Held by platform';
      default:
        return order.payoutStatus || '—';
    }
  }
}
